// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"lq-z","breadcrumbForward":"mq-z","breadcrumbBack":"nq-z","selected":"oq-z"};